import { useEffect, useState } from "react";
import { Select, Input, Button, Space, Radio, Typography, Form, DatePicker } from "antd";
import { PlusCircleOutlined, MinusCircleOutlined, CloseCircleOutlined, CheckCircleOutlined, EditOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { getData } from "../../../actions/apiCall";
import { putData } from "../../../actions/developer";
import DynamicSelect from "../../../components/Select/DynamicSelect";
const { Text } = Typography;
const { Option } = Select;
const { useForm } = Form;
import dayjs from "dayjs";
import moment from "moment";

type Condition = {
    field: string;
    operator: string;
    value: string;
    connector?: "AND" | "OR";
};

const numberOp = [
    "=",
    "<",
    "!=",
    "<=",
    ">",
    ">=",
    "between",
    "not between",
    "is empty",
    "is not empty"
]


const isValidDate = (value: any) => dayjs(value).isValid();

const normalizeObjectDates = (data: Record<string, any>): Record<string, any> => {
    const normalized: Record<string, any> = {};

    Object.entries(data).forEach(([key, value]) => {
        if (isValidDate(value)) {
            normalized[key] = dayjs(value); // convert to dayjs
        } else {
            normalized[key] = value; // leave as-is
        }
    });

    return normalized;
};


const LeadFilterForm = ({ condition, conditionIndex, reload }) => {
    const [formType, setFormType] = useState('');
    const [edit, setEdit] = useState(false);
    const [editForm, setEditForm] = useState(false);
    const [conditionValue, setConditionValue] = useState("");
    const [formData, setFormData] = useState<any>([]);
    const [condi, setCondi] = useState([]);
    const queryParams = new URLSearchParams(window.location.search);
    const [fieldValue, setFieldValue] = useState({});
    const moduleName = queryParams.get("module");
    const dispatch = useDispatch();
    const [form] = useForm();

    const operatorOptions = (field) => {
        const selectedField = formData.find((item) => item.id === field);
        if (selectedField) {
            const fieldType = selectedField.type;

            if (!fieldType.includes('timestamp')) {
                return [
                    "is",
                    "isn't",
                    "contains",
                    "doesn't contain",
                    "starts with",
                    "ends with",
                    "is empty",
                    "is not empty",
                ];
            } else {
                return numberOp;
            }
        } else {
            return [
                "is",
                "isn't",
                "contains",
                "doesn't contain",
                "starts with",
                "ends with",
                "is empty",
                "is not empty",
            ];
        }
    }

    useEffect(() => {
        if (moduleName) {
            getAllColumnName();
        }
    }, [moduleName]);

    useEffect(() => {
        if (condition) {
            getConditionData(condition);
        }
    }, [condition]);

    const getAllColumnName = async () => {
        const resData = await dispatch(getData(`/cms/emailKeysMap/all/columns/and/types`, { dependentField: moduleName }));
        if (resData) {
            setFormData(resData.data);
        }
    };

    const onSubmit = async (values) => {
        const resData = await dispatch(putData(`/work-flow-condition/${condition}`, { ...values, conditionType: formType }));
        if (resData) {
            setEditForm(false);
            getConditionData(condition);
            reload()
        }
    }

    const getConditionData = async (condition) => {
        const resData = await dispatch(getData(`/work-flow-condition/${condition}`));
        if (resData.code == 200) {
            const { conditionType, conditions } = resData.data;
            setFormType(conditionType);
            shoPannel(conditionType, conditions);
            const normalizedConditions = conditions.map(ele => normalizeObjectDates(ele));
            form?.setFieldsValue({ conditions: normalizedConditions, conditionType });

            const _fieldValue = normalizedConditions.reduce((acc, curr, index) => {
                acc[`${[index, 'field']}`] = curr.field;
                return acc;
            }, {});

            setFieldValue(_fieldValue);

            setCondi(resData.data.conditions)
            getPattern(conditions);
        }
    }

    function generateFullyNestedExpression(conditions: Condition[]): string {
        if (conditions.length === 0) return "";

        let expression = '1';

        for (let i = 1; i < conditions.length; i++) {
            const { connector } = conditions[i];
            if (!connector) continue;
            expression = `(${expression} ${connector.toLowerCase()} ${i + 1})`;
        }

        return expression;
    }

    const getPattern = (conditions: Condition[]) => {
        const pattern = generateFullyNestedExpression(conditions || []);
        setConditionValue(pattern);
    }

    const toggleConnectorAtIndex = (index: number) => {
        const conditions = form?.getFieldValue("conditions") || [];
        const current = conditions[index]?.connector || "AND";
        const updated = conditions.map((item, idx) =>
            idx === index ? { ...item, connector: current === "AND" ? "OR" : "AND" } : item
        );
        const normalizedConditions = updated.map(ele => normalizeObjectDates(ele));
        form?.setFieldsValue({ conditions: normalizedConditions });
        const _fieldValue = updated.reduce((acc, curr, index) => {
            acc[`${[index, 'field']}`] = curr.field;
            return acc;
        }, {});
        setFieldValue(_fieldValue);
        getPattern(updated);
    };

    const shoPannel = (_formType, __condition) => {
        if (_formType == 'maching_condition' && !__condition[0].field) {
            setEditForm(true);
        }
    };
    const RenderForm = (field) => {
        const selectedField = formData.find((item) => item.id === field);
        if (selectedField) {
            const fieldType = selectedField.type;

            if (fieldType.includes('object')) {
                return <DynamicSelect
                    isEncrypted={false}
                    searchApi="/leads-types"
                    render={(item) => item.name}
                    addNew={false}
                    idKey="_id"
                />
            } else if (fieldType.includes('timestamp')) {
                return <DatePicker
                    format="YYYY-MM-DD" />
            } else if (fieldType.includes('boolean')) {
                return <Select placeholder="Select Value" className="w-40">
                    <Option value="true">True</Option>
                    <Option value="false">False</Option>
                </Select>
            } else {
                return <Input />
            }
        } else {
            return <Input />
        }
    }

    const getValidValue = (value) => {
        if (typeof value === 'boolean' || value === 'true' || value === 'false') {
            return `${value}` === 'true' ? "Yes" : "No";
        }
        return value;
    }


    return (
        <div className={`w - full`}>
            {editForm ? <>
                <h2 className="text-xl font-semibold mb-4">
                    Which <span className="font-bold">leads</span> would you like to apply the rule to?
                </h2>
                <div>
                    <Form form={form} layout="vertical"
                        onFinish={(values) => onSubmit(values)}
                        name="dynamic_conditions_form"
                        onValuesChange={(value, values) => {
                            getPattern(values.conditions);
                        }}
                    >
                        <div className="mb-6">
                            <Form.Item name="conditionType" >
                                <Radio.Group className="flex items-center space-x-4"
                                    onChange={(e => {
                                        setFormType(e.target.value)
                                    })}
                                >
                                    <Radio value="maching_condition" name="maching_condition" className="flex items-center space-x-2">
                                        Leads matching certain conditions
                                    </Radio>

                                    {conditionIndex == 0 && <Radio value="all" name="all" className="flex items-center space-x-2">
                                        All Leads
                                    </Radio>}
                                    {conditionIndex > 0 && <Radio value="not_matching_condition" name="not_matching_condition" className="flex items-center space-x-2">
                                        Leads that do not meet any of the above conditions
                                    </Radio>}
                                </Radio.Group>
                            </Form.Item>
                        </div>
                        {formType == 'maching_condition' && <Form.List name="conditions" initialValue={[{}]}>
                            {(fields, { add, remove }) => (
                                <>
                                    {fields.map(({ key, name, ...restField }, index) => (
                                        <div key={key} className="mb-4">
                                            {index !== 0 && (
                                                <div
                                                    className={`flex items - center ${form?.getFieldValue(['conditions', name, 'connector']) === "AND" ? "ml-1" : "ml-2"
                                                        } -mt - 4`}
                                                >
                                                    <div className="flex items-center flex-col">
                                                        <div className="h-3 border-r"></div>
                                                        <span
                                                            className="text-blue-900 text-[11px] cursor-pointer"
                                                            onClick={() => toggleConnectorAtIndex(name)}
                                                        >
                                                            {form?.getFieldValue(["conditions", name, "connector"]) || "AND"}
                                                        </span>
                                                        <div className="h-3 border-r"></div>
                                                    </div>
                                                </div>
                                            )}

                                            <div className="flex items-center space-x-3">
                                                <div className="text-gray-500 rounded-full border border-gray-300 w-8 h-8 min-w-[2rem] flex items-center justify-center text-sm font-medium">
                                                    {index + 1}
                                                </div>

                                                <Form.Item
                                                    {...restField}
                                                    name={[name, "field"]}
                                                    className="mb-0 w-50 min-w-50"
                                                    rules={[{ required: true, message: "Select field" }]}

                                                >
                                                    <Select placeholder="Select field"
                                                        onChange={(value) => {
                                                            setFieldValue((prev) => ({ ...prev, [`${[name, "field"]}`]: value }));
                                                        }}
                                                        allowClear
                                                        showSearch
                                                    >
                                                        {formData.map((opt) => (
                                                            <Option key={opt.id} value={opt.id}>
                                                                {opt.name}
                                                            </Option>
                                                        ))}
                                                    </Select>
                                                </Form.Item>

                                                <Form.Item
                                                    {...restField}
                                                    name={[name, "operator"]}
                                                    className="mb-0 w-40 min-w-40"
                                                    rules={[{ required: true, message: "Select operator" }]}
                                                >
                                                    <Select placeholder="Operator">
                                                        {operatorOptions(fieldValue[`${[name, "field"]}`]).map((opt) => (
                                                            <Option key={opt} value={opt}>
                                                                {opt}
                                                            </Option>
                                                        ))}
                                                    </Select>
                                                </Form.Item>

                                                <Form.Item
                                                    {...restField}
                                                    name={[name, "value"]}
                                                    className="mb-0 w-full"
                                                    rules={[{ required: true, message: "Field Required" }]}
                                                >
                                                    {RenderForm(fieldValue[`${[name, "field"]}`])}
                                                </Form.Item>

                                                <Space direction="horizontal" size="small" className="w-40">
                                                    <Button
                                                        icon={<MinusCircleOutlined />}
                                                        danger
                                                        type="text"
                                                        className="min-w-[2rem]"
                                                        onClick={() => remove(name)}
                                                        disabled={fields.length <= 1}
                                                    />
                                                    {index === fields.length - 1 && (
                                                        <Button
                                                            icon={<PlusCircleOutlined />}
                                                            type="text"
                                                            className="min-w-[2rem]"
                                                            onClick={() => add({ connector: "AND" })}
                                                        />
                                                    )}
                                                </Space>
                                            </div>
                                        </div>
                                    ))}
                                </>
                            )}
                        </Form.List>}
                    </Form>
                    {formType == 'maching_condition' && <div className="flex items-center justify-between mt-4">
                        <div className="text-sm text-gray-500">
                            <Space direction="horizontal">
                                Criteria Pattern: {!edit && <p>{conditionValue}</p>}
                                {edit ? <Space direction="horizontal" size="small">
                                    <Input className="w-60" value={conditionValue} onChange={(e) => setConditionValue(e.target.value)} />
                                    <Button type="link" onClick={() => setEdit(false)} icon={<CheckCircleOutlined className="!text-lg" />} />
                                    <Button type="link" onClick={() => setEdit(false)} icon={<CloseCircleOutlined className="text-gray-900 hover:text-gray-700 !text-lg" />} />
                                </Space>
                                    :
                                    <Button type="link" onClick={() => setEdit(true)}>Edit Pattern</Button>
                                }
                            </Space>
                        </div>
                    </div>}
                </div>

                <div className="flex justify-end">
                    <Button type="primary" size="middle" onClick={() => form?.submit()}>
                        Done
                    </Button>
                </div>
            </> :
                <>
                    <div className="group">
                        {formType == 'maching_condition' && condi.map((ele, ind) => <div key={ind} className="">
                            <div className="text-gray-500 text-sm">{ele.connector}</div>
                            <Text>{ele.field} <b>{ele.operator}</b> {isValidDate(ele.value) ? moment(ele.value).format('DD MMM, YYYY') : getValidValue(ele.value)}</Text>
                        </div>)}
                        {formType == 'not_matching_condition' && <div>
                            <Text>For any leads that do not meet the above conditions.</Text>
                        </div>}
                        {formType == 'all' && <div>
                            <Text>All Leads</Text>
                        </div>}
                    </div>
                    <Button type="text" className="absolute top-2 right-8 group-hover:block hidden" onClick={() => setEditForm(true)} >
                        <EditOutlined />
                    </Button>
                </>
            }
        </div >
    );
};

export default LeadFilterForm;
